import Header from "components/Headers/Header";
import ResolutionChat from "components/ResolutionChat";
import { Card, Container } from "reactstrap";

function ResolutionDetail() {
  return (
    <>
      <Header />
      <Container fluid>
        <h3 className="text-center mb-3">Resolution Detail</h3>
        <Card className="p-3">
          <ResolutionChat />
        </Card>
      </Container>
    </>
  );
}

export default ResolutionDetail;
